import { Eye, Pencil, Trash2 } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { UserDropdown } from '@/constants/user'
import { useTranslations } from '@/hooks/useTranslations'
import { useProfileData } from '@/hooks/useProfile'

type BillRowActionsProps = {
  onAction: (eventName: UserDropdown) => void
}

export function BillRowActions({ onAction }: BillRowActionsProps) {
  const t = useTranslations('common')
  const { checkPermission } = useProfileData()

  return (
    <div className="flex items-center justify-end gap-0.5">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-9 w-9 shrink-0 text-muted-foreground hover:text-foreground"
        title={t('dropdown.view')}
        aria-label={t('dropdown.view')}
        onClick={() => onAction(UserDropdown.VIEW)}
      >
        <Eye className="h-4 w-4" aria-hidden />
      </Button>
      {checkPermission('edit_bill') ? (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-9 w-9 shrink-0 text-muted-foreground hover:text-foreground"
          title={t('dropdown.edit')}
          aria-label={t('dropdown.edit')}
          onClick={() => onAction(UserDropdown.EDIT)}
        >
          <Pencil className="h-4 w-4" aria-hidden />
        </Button>
      ) : null}
      {checkPermission('delete_bill') ? (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-9 w-9 shrink-0 text-muted-foreground hover:bg-destructive/10 hover:text-destructive"
          title={t('dropdown.delete')}
          aria-label={t('dropdown.delete')}
          onClick={() => onAction(UserDropdown.DELETE)}
        >
          <Trash2 className="h-4 w-4" aria-hidden />
        </Button>
      ) : null}
    </div>
  )
}
